import ArticlePage from '@/components/feature/ArticlePage';
import { pillarArticles } from '@/mocks/pillarArticles';

export default function PillarArticle({ slug }: { slug: string }) {
  const article = pillarArticles.find((a) => a.slug === slug);
  if (!article) return null;
  return <ArticlePage article={article} />;
}